import { safeDefine } from "../../registration/safe-define.js";
import { SliderValueElement } from "../../ui/slider/value.js";
//#region src/define/ui/slider-value.ts
safeDefine(SliderValueElement);
//#endregion
